import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import ToggleCaptionIcon from './icons/caption.svg';


export default class ToggleCaptionUI extends Plugin {
  init() {
    const editor = this.editor;
    const t = editor.t;
    
    editor.ui.componentFactory.add('togglecaption', locale => {
      const view = new ButtonView(locale);
      view.set({
        label: t('Toggle Caption'),
        tooltip: true,
        withText: false,
        icon: ToggleCaptionIcon,
      });

      this.listenTo(view, 'execute', () => {
          const selectedElement = this.editor.model.document.selection.getSelectedElement();
          if (selectedElement && selectedElement.name === 'figureTag') {

            const figcaptionElement = selectedElement._children._nodes.filter(e => e.name === 'figcaptionTag');

            if(figcaptionElement.length > 0){
              this.editor.model.change(writer => {
                editor.fire('removeMediaCaption',{range : writer.createRangeOn(figcaptionElement[0])});
                writer.remove(figcaptionElement[0]);  
              }); 
            } else {
              this.editor.model.change(writer => {
                const figureCaption = writer.createElement('figcaptionTag',{
                  'class':'media-caption-class',
                  'style': 'text-align:left'
                });
                writer.append(writer.createText('Enter image caption') , figureCaption);
                this.editor.model.insertContent(
                  figureCaption,
                  selectedElement,"end"
                ); 
              });
            }
          }
      });

      return view;
    });

  }
}